import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  public readonly sAdmin: number = 100;
  public readonly admin: number = 80;
  public readonly serviceTechnical: number = 20;
  public readonly user: number = 0;

  permissions: any = {
    0: 'user',
    1: 'admin',
    100: 'superadmin'
  }

  constructor(
    private authService: AuthService,
    public router: Router,
  ) { }

  verifyAccess() {
    if(this.authService.user?.is_admin === undefined || this.authService.user?.is_admin === 0) {
      this.router.navigate(['rekbots-list']);
    }
  }

  getPermissionName(permission: number) {
    return this.permissions[permission];
  }

  getUserPermissions(user: User) {
    return user.role!.role_id;

    // if(user.is_admin === undefined) {
    //   return this.permissions[0];
    // } else {
    //   return this.permissions[user.is_admin];
    // }
  }

}
